export const serviceName = "freewall-compiler";
